import React, { useState } from 'react';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import PropTypes from 'prop-types';
import ConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import ClassUtility from '../../../../utility/ClassUtility';
import ThresholdSelect from '../../AlertForms/ThresholdSelect/ThresholdSelect';
import RaaDefaultButton from '../../../common/RaaDefaultButton/RaaDefaultButton';
import ChannelSelector from '../../AlertForms/ChannelSelector/ChannelSelector';
import SingleAlert from '../../../../classes/SingleAlert';
import TagsMultiSelect from './TagsMultiselect/TagsMultiSelect';

function EditAlertConditionFormWrapper(props) {
  const {
    handleSubmitAlertCondition,
    isFormSubmitting,
    submitBtnText,
    formErrors,
    editedAlert,
    setEditedAlert,
    handleUpdateChannelKey,
    cancelEditCondition,
  } = props;

  const [isDeviceSensor, setIsDeviceSensor] = useState(false);

  const isSubmitDisabled = (
    editedAlert.channelKey.channelType === 0
      && editedAlert.channelKey.channelIndex === 0
  );

  return (
    <div className="card">
      <div className="row justify-content-center">
        <div className="col-sm-8">
          <div className="text-center">
            <h5 className="my-2">Change Source and Threshold</h5>
          </div>

          <hr />
          <FormErrorHandler errorList={formErrors}>
            <form
              id="alert-change-form"
              onSubmit={handleSubmitAlertCondition}
            >
              <div className="form-group row">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="col-form-label col-md-3 text-md-right">Name</label>
                <div className="col-sm-8">
                  <AltErrorWrapper fieldId="description">
                    <input
                      type="text"
                      name="description"
                      className="form-control"
                      value={editedAlert.description}
                      onChange={(e) => {
                        const updatedAlert = ClassUtility.cloneObject(editedAlert);
                        updatedAlert.description = e.target.value;
                        setEditedAlert(updatedAlert);
                      }}
                    />
                  </AltErrorWrapper>
                </div>
              </div>

              <div className="form-group row">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="col-form-label col-md-3 text-md-right">Tags</label>
                <div className="col-sm-8">
                  <TagsMultiSelect
                    selectedTags={editedAlert.tags}
                    setSelectedTags={(tagIds) => {
                      const updatedAlert = ClassUtility.cloneObject(editedAlert);
                      updatedAlert.tags = tagIds;
                      setEditedAlert(updatedAlert);
                    }}
                  />
                </div>
              </div>

              <ChannelSelector
                errorList={formErrors}
                channelKey={editedAlert.channelKey}
                updateChannelKey={handleUpdateChannelKey}
                setIsDeviceSensor={setIsDeviceSensor}
              />

              <ThresholdSelect
                errorList={formErrors}
                alert={editedAlert}
                setAlert={setEditedAlert}
              />
              <ConditionalRender show={isDeviceSensor}>
                <div className="form-group form-inline row">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label className="col-lg-2 control-label" />
                  <div className="col-auto col-lg-10">
                    <div className="alert alert-info">
                      <div className="float-left mr-1">
                        <Icon icon="info-circle" />
                      </div>
                      <div style={{ marginLeft: '1.5em' }}>
                        <p className="mb-0">
                          If you select
                          {' '}
                          <strong>Device</strong>
                          {' '}
                          from the
                          {' '}
                          <strong>Sensor</strong>
                          {' '}
                          drop-down menu, you may
                          alert
                          on these types of connections:
                        </p>
                        <p>
                          <strong>-Link Connection: </strong>
                          {' '}
                          Is your Room Alert device connected to Room Alert Link
                          software?
                          {' '}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://avtech.com/articles/16289/"
                          >
                            <em>
                              For more info, click
                              here.
                            </em>
                          </a>
                          <br />
                          <strong>-Push Status:</strong>
                          {' '}
                          Is your Room Alert device pushing data to RoomAlert.com?
                          {' '}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://avtech.com/articles/15801/"
                          >
                            <em>
                              For more info, click
                              here.
                            </em>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ConditionalRender>

              <hr />

              <div className="row mb-3">
                <div className="col offset-sm-3">
                  <button
                    type="submit"
                    disabled={isSubmitDisabled || isFormSubmitting}
                    className="btn btn-primary mr-1"
                  >
                    {submitBtnText}
                  </button>
                  <RaaDefaultButton
                    onClick={cancelEditCondition}
                  >
                    Cancel
                  </RaaDefaultButton>
                </div>
              </div>
            </form>
          </FormErrorHandler>
        </div>
      </div>
    </div>
  );
}

EditAlertConditionFormWrapper.propTypes = {
  isFormSubmitting: PropTypes.bool.isRequired,
  submitBtnText: PropTypes.string.isRequired,
  handleSubmitAlertCondition: PropTypes.func.isRequired,
  formErrors: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
  editedAlert: PropTypes.instanceOf(SingleAlert).isRequired,
  setEditedAlert: PropTypes.func.isRequired,
  handleUpdateChannelKey: PropTypes.func.isRequired,
  cancelEditCondition: PropTypes.func.isRequired,
};

export default EditAlertConditionFormWrapper;
